import { useMutation, useQueryClient } from '@tanstack/react-query';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { useSetNotification } from '../../../context/Notification';
import { CreateExternalUserParams, ExternalUser } from '../types';
import { EXTERNAL_USER_KEY, USERS_LIST_KEY } from './constants';

const useCreateExternalUser = () => {
    const req = useRequest();
    const setNotification = useSetNotification();
    const queryClient = useQueryClient();

    return useMutation<ExternalUser, { errors: string[] }, CreateExternalUserParams>({
        mutationFn: (body) => {
            return req<ExternalUser>({
                url: `${envVars.API_RTM_HOSTNAME}enterprise/external-user/`,
                method: 'POST',
                body
            });
        },
        onSuccess: () => {
            setNotification({ message: 'External user created', icon: 'checkmark' });
            queryClient.invalidateQueries({ queryKey: [EXTERNAL_USER_KEY] });
            queryClient.invalidateQueries({ queryKey: [USERS_LIST_KEY] });
        }
    });
};

export default useCreateExternalUser;
